import { eventKey as UPLT_EVENT_KEY } from "@faire/web-api--source/events/infra/timing/userPerceivedLoadTiming";

import { LoadTimingResult } from "../performance/userPerceivedLoadTiming/types";
import { TraceEventTracker } from "../pete/TraceEventMarkerTracker";

interface PayloadParams {
  name: string;
  loadType?: string;
  status: string;
  result: LoadTimingResult;
  userToken: string;
  isDesktopAndAbove?: boolean;
  isMobile?: boolean;
}

export function generateTracingMetadata({
  name,
  loadType,
  status,
  result,
  userToken,
  isDesktopAndAbove,
  isMobile,
}: PayloadParams) {
  return {
    loadType,
    name,
    status,
    endTime: result.endTime,
    lastImageLoadTime: result.lastImageLoadTime ?? undefined,
    mainThreadQuietTime: result.mainThreadQuietTime ?? undefined,
    pageMountTime: result.pageMountTime ?? undefined,
    pageReadyTime: result.pageReadyTime ?? undefined,
    userToken: userToken,
    isDesktopAndAbove: isDesktopAndAbove,
    isMobile: isMobile,
    sourceEventHash:
      TraceEventTracker.get().getTraceHash(UPLT_EVENT_KEY).sourceEventHash,
  };
}
